import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '内容导航',
      links: [
        { label: '核心理念', to: '/category/core-philosophy' },
        { label: '实践方法', to: '/category/practice-methods' },
        { label: '应用场景', to: '/category/application-scenarios' },
        { label: '思维训练', to: '/category/mind-training' },
        { label: '案例分析', to: '/category/case-studies' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌故事', to: '/about' },
        { label: '联系我们', to: '/about' },
        { label: '隐私政策', to: '/about' },
      ],
    },
    {
      title: '热门文章',
      links: [
        { label: '秘密教学的起源', to: '/article/origin-of-secret-teaching' },
        { label: '五大核心原则', to: '/article/core-principles-of-secret-learning' },
        { label: '心智模型构建', to: '/article/mental-model-building-guide' },
        { label: '商业世界中的秘密教学', to: '/article/hidden-knowledge-in-business' },
      ],
    },
  ];

  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="px-4 md:px-6 py-14 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-foreground-900">
              {siteConfig.siteName}
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {siteConfig.siteDescription}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-secondary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-secondary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100 text-foreground-600 hover:text-secondary-500 transition-colors" aria-label="知乎">
                <i className="ri-zhihu-line text-base" />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteConfig.siteName}. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-500 transition-colors">
              京ICP备2024XXXXXXXX号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}